<div class="space-y-5">
  <!-- Page Header -->
  <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h1 class="text-xl font-bold text-gray-900 dark:text-white">Negocios</h1>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Gestión de tenants registrados en la plataforma</p>
    </div>
    <div class="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
      <span class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 px-2.5 py-1 text-xs font-medium dark:bg-gray-800">
        {{ totalCount }} registros
      </span>
    </div>
  </div>

  <!-- Filters Bar -->
  <div class="rounded-2xl border border-gray-200 bg-white p-4 dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="flex flex-wrap items-end gap-4">
      <div class="min-w-[140px]">
        <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Estado</label>
        <select [(ngModel)]="isActiveFilter" (change)="onFilterChange()"
          class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 transition focus:border-brand-500 focus:ring-1 focus:ring-brand-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
          aria-label="Filtrar por estado">
          <option value="all">Todos</option>
          <option value="true">Activos</option>
          <option value="false">Inactivos</option>
        </select>
      </div>
      <div class="min-w-[160px]">
        <label class="mb-1.5 block text-xs font-medium text-gray-600 dark:text-gray-400">Membresía</label>
        <select [(ngModel)]="membershipStatusFilter" (change)="onFilterChange()"
          class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 transition focus:border-brand-500 focus:ring-1 focus:ring-brand-500 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300"
          aria-label="Filtrar por membresía">
          <option value="all">Todas</option>
          <option value="Activa">Activa</option>
          <option value="En Período de Prueba">En Prueba</option>
          <option value="Vencida">Vencida</option>
        </select>
      </div>
      @if (isActiveFilter !== 'all' || membershipStatusFilter !== 'all') {
      <button (click)="isActiveFilter = 'all'; membershipStatusFilter = 'all'; onFilterChange()"
        class="rounded-lg px-3 py-2 text-xs font-medium text-brand-600 transition hover:bg-brand-50 dark:text-brand-400 dark:hover:bg-brand-500/10">
        Limpiar filtros
      </button>
      }
    </div>
  </div>

  <!-- Businesses Table -->
  <app-data-table [columns]="columns" [rows]="businesses()" [loading]="loading()" [searchTerm]="searchTerm"
    (search)="onSearch($event)" [page]="page" [pageSize]="pageSize" [totalCount]="totalCount"
    (pageChange)="onPageChange($event)" [stickyHeader]="true" searchPlaceholder="Buscar negocio por nombre..."
    [height]="'65vh'">

    <!-- Business Name Cell -->
    <ng-template tableCell="business_name" let-row>
      <div class="flex items-center gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-sm font-bold text-brand-600 dark:bg-brand-500/10 dark:text-brand-400">
          {{ row.name?.charAt(0)?.toUpperCase() }}
        </div>
        <div class="min-w-0">
          <p class="truncate text-sm font-medium text-gray-900 dark:text-white">{{ row.name }}</p>
          <p class="text-xs text-gray-500 dark:text-gray-400">ID: {{ row.businessId | slice:0:8 }}...</p>
        </div>
      </div>
    </ng-template>

    <!-- Status Badge -->
    <ng-template tableCell="status_badge" let-row>
      <span class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
        [class]="getStatusBadgeClass(row.isActive)">
        <span class="mr-1.5 h-1.5 w-1.5 rounded-full"
          [class]="row.isActive ? 'bg-success-500' : 'bg-gray-400'"></span>
        {{ row.isActive ? 'Activo' : 'Inactivo' }}
      </span>
    </ng-template>

    <!-- Membership Badge -->
    <ng-template tableCell="membership_badge" let-row>
      <span class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
        [class]="getMembershipBadgeClass(row.membershipStatus)">
        {{ row.membershipStatus || 'Sin membresía' }}
      </span>
    </ng-template>

    <!-- Expiration -->
    <ng-template tableCell="expiration" let-row>
      <span class="text-sm text-gray-600 dark:text-gray-400">
        {{ formatDate(row.membershipEndDate || row.trialEndDate) }}
      </span>
    </ng-template>

    <!-- Actions -->
    <ng-template tableCell="actions" let-row>
      <div class="flex items-center justify-end gap-1">
        <!-- Impersonate -->
        <button (click)="onImpersonate(row)" title="Impersonar"
          class="rounded-lg p-2 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
          aria-label="Impersonar negocio">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z"/>
          </svg>
        </button>
        <!-- Toggle Active -->
        <button (click)="onToggleActive(row)" [title]="row.isActive ? 'Desactivar' : 'Activar'"
          class="rounded-lg p-2 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
          [attr.aria-label]="row.isActive ? 'Desactivar negocio' : 'Activar negocio'">
          <svg *ngIf="row.isActive" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/>
          </svg>
          <svg *ngIf="!row.isActive" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="5 3 19 12 5 21 5 3"/>
          </svg>
        </button>
        <!-- More Actions -->
        <button (click)="onOpenActions(row)" title="Más acciones"
          class="rounded-lg p-2 text-gray-500 transition hover:bg-gray-100 hover:text-gray-700 dark:text-gray-400 dark:hover:bg-gray-800 dark:hover:text-gray-200"
          aria-label="Más acciones">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/>
          </svg>
        </button>
      </div>
    </ng-template>
  </app-data-table>
</div>

<!-- Confirm Modal -->
<app-confirm-modal
  [open]="showConfirmModal()"
  [title]="confirmModalTitle"
  [subtitle]="confirmModalSubtitle"
  [variant]="confirmModalVariant"
  [loading]="confirmLoading()"
  confirmText="Sí, confirmar"
  cancelText="Cancelar"
  (confirm)="onConfirmAction()"
  (cancel)="onCancelAction()">
</app-confirm-modal>

<!-- Business Actions Slide-over Panel -->
@if (showActionsPanel() && selectedBusiness()) {
<app-business-actions
  [business]="selectedBusiness()!"
  (close)="onCloseActions()"
  (actionCompleted)="onActionCompleted()">
</app-business-actions>
}
